import React, { Component } from 'react'
import "./CustomerInformation.css"
import moment from 'moment';
class OffersinWallet extends Component {
    constructor(props){
        super(props)
        this.state={}
   
    }
    componentDidMount(){
        if(this.props.setNoOfPages)
        {
            const timer = setTimeout(() => 
            {this.props.setNoOfPages(this.props.OffersCount)
               clearTimeout(timer)
            }
            , 200);
           
        }
    }
    render() {
        return (
            <>
                <table className='table-p'>
                    <thead className='heading-tab'>
                        <tr>
                            <th>Sr. #</th>
                            <th>Partner</th>
                            <th>Offer Term</th>
                            <th>Discount Type</th>
                            <th>Claim Date</th>
                            <th>Points Paid</th>
                            <th>Expiry Date</th>
                        </tr>

                    </thead>
                    <tbody className='bodyoftable'>
                        {this.props.data.length>0?this.props.data.map((res, index) => {
              return (
                        <tr
                        key={index}
                        >
                            <td>{(index+1)}</td>
                            <td>{res.partner_name}</td>
                            <td>{res.legalese?res.legalese.length<20?res.legalese:res.legalese.substring(0,20)+"...":"No Terms & Conditions applied."}</td>
                            <td style={{color:"#F6853F"}}>{res.Offer_Type}</td>
                            <td>{moment(res.coupon_issue_dttm).format('MM/DD/YYYY')}</td>
                            <td>{res.points_paid}</td>
                            <td>{moment(res.promotion_end_date).format('MM/DD/YYYY')}</td>
                        </tr>
                       
                       );
             }):<tr><td>No search records available</td></tr>} 
                    </tbody>
                </table>
            </>
        )
    }
}

export default OffersinWallet
